export default class Feature {
  private _title: string
  private _tooltip?: string

  public constructor(title: string, tooltip = '') {
    this._title = title
    this._tooltip = tooltip
  }

  get title() {
    return this._title
  }

  get tooltip() {
    return this._tooltip
  }
}
